import { localStorage } from '@catalogo/core-local-storage';
import mercadoLogin from './mercado';
import freight from './freight';
import recommendations from './recommendations';
import b2wAds from './b2w-ads';
import cartFiler from './cart-filler';

export default (config, cache, device) => ({
  Query: {
    recentSearches: () => localStorage.get('recentSearches').reverse(),
    freight: freight(config, cache),
    recommendations: recommendations(config, cache, device),
    b2wAds: b2wAds(config, cache, device),
    cartFiller: cartFiler(config),
  },
  Mutation: {
    removeRecentSearches: (_, search) => localStorage.remove('recentSearches', search),
    addRecentSearches: (_, search) => localStorage.add('recentSearches', { ...search, id: Date.now() }),
    mercadoLogin: mercadoLogin(config),
  },
});
